import React, { useEffect, useState } from 'react'
import Modal from 'src/component/Global/Modal';
import System from 'src/helper/system';
import { useBOMStore } from 'src/hooks/bom';
import { useForecastStore } from 'src/hooks/forecast';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import Constants from 'src/support/Constants';


const DownloadForecastPopup = (props) => {
    const [status, SetStatus] = useState(true);
    const [{ }, { download_forecast }, { }] = useForecastStore();
    const [{ }, { fetch_download_file_preference }, { save_download_file_preference }] = useBOMStore();
    const [forecast, setForecast] = useState({
        export: 'csv',
        preference: ''
    });
    const [__check] = useAxiosIndicatorCheck();


    useEffect(() => {
        const getSavedDownloadPreference = async () => {
            let res = await fetch_download_file_preference({ prefType: Constants.ForecastPreferenceType });
            if (res && res?.payload) {
                setForecast({
                    export: res?.payload?.preference == 'yes' ? res?.payload?.export_type : 'csv', // default selection
                    preference: res?.payload?.preference == 'yes' ? 'yes' : ''
                });
            }
        }
        getSavedDownloadPreference();
    }, [])

    const downloadForecast = async () => {
        let params = {
            fileType: forecast.export
        };
        let res = await download_forecast(params);
        if (res && res?.data) {
            setTimeout(() => {
                showDownloadMessage();
            },1000)
        }

        // Save Preference
        let reqBody = {
            export_type: forecast.export,
            preference: forecast.preference
        }
        params = {
            prefType: Constants.ForecastPreferenceType,
            preferenceValue: JSON.stringify(reqBody)
        }
        await save_download_file_preference(params);
        SetStatus(false)
    }

    const showDownloadMessage = () => {
        System.alert(Constants.downloadMsg, 'success', 'exportMsg')
    }

    const onHide = (action = true) => {
        SetStatus(false)
    };

    return (
        <>
            <Modal show={status} onHide={() => {
                onHide()
            }}>
                <div className="avnet-modal modal-375">
                    <div className="avnet-modal-inner">
                        {/* Modal Header */}
                        <button type="button" className="close py-3" data-dismiss="modal"
                            onClick={() => {
                                SetStatus(false)
                            }}>×
                        </button>
                        <div className="modal-header justify-content-center mt-0">
                            <h3 className="pcn-modal-heading pl-5">Download Forecast</h3>
                        </div>
                        {/* Modal body */}
                        <div className="modal-body py-0">
                            <div className="light-card m-b-10">
                                <div className="light-card-header">
                                    <div className="light-card-title font-arial">
                                        Select file type to export. <span className="font-normal"><i>(required)</i></span>
                                    </div>
                                </div>
                                <div className="light-card-body pb-0">
                                    <div className="form-check-inline d-flex flex-column">
                                        <div className="form-check form-check-inline pr-5 pb-3">
                                            <input type="radio" className="form-check-input font-14"
                                                id="customRadio"
                                                value="csv"
                                                name='example'
                                                checked={forecast.export === "csv"}
                                                onChange={(e) => setForecast({ ...forecast, export: e.target.value })}
                                            />
                                            <label className="form-check-label mt-0"
                                                htmlFor="customRadio">CSV</label>
                                        </div>
                                        <div className="form-check form-check-inline pr-5 pb-3">
                                            <input type="radio" className="form-check-input font-14"
                                                id="customRadio2"
                                                value="xlsx"
                                                name="example"
                                                checked={forecast.export === "xlsx"}
                                                onChange={(e) => setForecast({ ...forecast, export: e.target.value })} />
                                            <label className="form-check-label mt-0"
                                                htmlFor="customRadio2">XLSX</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="save-prefrence mt-4">
                                <div className="col-12">
                                    <div className="form-check m-b-15">
                                        <input type="checkbox" className="form-check-input font-14"
                                            id="save_preference"
                                            name="save_preference"
                                            value="yes"
                                            checked={forecast?.preference === "yes"}
                                            onClick={(e) => {
                                                setForecast({ ...forecast, preference: e.target.checked ? e.target.value : '' })
                                            }}
                                        />
                                        <label className="form-check-label" htmlFor="save_preference">Save my
                                            selection
                                            preference</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {__check(['DOWNLOAD_FORECAST_API_CALL']).render}
                        {!__check(['DOWNLOAD_FORECAST_API_CALL']).status &&
                            <div className="modal-footer text-center">
                                <div className="modal-footer-actions">

                                    <button type="button" className="bs5 btn btn-secondary minw-auto"
                                        data-bs-toggle="modal"
                                        onClick={() => {
                                            SetStatus(false)
                                        }}>
                                        Cancel
                                    </button>
                                    <button type="submit" className="bs5 btn btn-primary minw-auto"
                                        data-bs-toggle="modal"
                                        onClick={() => {
                                            downloadForecast()
                                        }}>
                                        Download
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </Modal>
        </>
    )
};

export default DownloadForecastPopup;
